import React, { useEffect, useState, useRef } from "react";
import Header from "../header/header";
import { useSelector } from "react-redux";
import { authSelector } from "../../store/selectors";
import { message } from "antd";
import { format } from "date-fns";
import {
  getNozelSale,
  getAllTank,
  updateTankBal,
} from "../../api/endpoints/saleData";
import { getSiteRefrence } from "../../api/endpoints/refrences";
import "./saleData.css";
import { getAllItemsSearch } from "../../api/endpoints/search";

const getColorForTank = (itemCode) => {
  switch (itemCode) {
    case 1:
      return { color1: "#90EE90", color2: "#008000" };
    case 2:
      return { color1: "#FFD700", color2: "#FFA500" };
    case 3:
      return { color1: "#FF6347", color2: "#B22222" };
    default:
      return { color1: "#ccc", color2: "#333" };
  }
};

const QuantityCircle = ({ initial, used, total, color1, color2, id }) => {
  const diameter = 150;
  const viewBox = `0 0 ${diameter} ${diameter}`;
  const remainingVolume = initial - used;
  const percentage = (remainingVolume / total) * 100;
  const fillHeight = Math.max(0, diameter * (percentage / 100));
  const gradientId = `gradient-fill-${id}`;
  const clipPathId = `clip-path-${id}`;

  return (
    <svg width={diameter} height={diameter} viewBox={viewBox}>
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="100%" x2="0%" y2="0%">
          <stop offset="0%" style={{ stopColor: color1, stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: color2, stopOpacity: 1 }} />
        </linearGradient>
        <clipPath id={clipPathId}>
          <rect
            x="0"
            y={diameter - fillHeight}
            width={diameter}
            height={fillHeight}
          />
        </clipPath>
      </defs>
      <circle
        cx={diameter / 2}
        cy={diameter / 2}
        r={diameter / 2}
        fill={`url(#${gradientId})`}
        clipPath={`url(#${clipPathId})`}
      />
      <circle
        cx={diameter / 2}
        cy={diameter / 2}
        r={diameter / 2}
        fill="none"
        stroke="#fff"
        strokeWidth="2"
      />
      <text
        x="50%"
        y="50%"
        alignmentBaseline="central"
        textAnchor="middle"
        fontSize="20"
        fill="#333"
      >
        {percentage.toFixed(0)}%
      </text>
    </svg>
  );
};

const Saledata = () => {
  const { user, access_token } = useSelector(authSelector);
  const [saleData, setSaleData] = useState([]);
  const [tankData, setTankData] = useState([]);
  const [state, setState] = useState({
    siteName: "",
    siteAddress: "",
    siteDealer: "",
  });

  const [itemState, setItemState] = useState({
    itemNamePetrol: "",
    itemRatePetrol: "",
    itemNameDiesel: "",
    itemRateDiesel: "",
    itemNameHOBC: "",
    itemRateHOBC: "",
  });

  const [tankLimit, setTankLimit] = useState({
    limitPetrol: "",
    limitDiesel: "",
    limitHOBC: "",
  });

  const fetchItems = async () => {
    try {
      const res = await getAllItemsSearch(access_token);

      if (res) {
        const data = res;

        const petrol = data.find((item) => item.itemCode === 1);
        const diesel = data.find((item) => item.itemCode === 2);
        const hobc = data.find((item) => item.itemCode === 3);

        setItemState({
          itemNamePetrol: petrol?.itemName || "",
          itemRatePetrol: petrol?.sRate || 0,

          itemNameDiesel: diesel?.itemName || "",
          itemRateDiesel: diesel?.sRate || 0,

          itemNameHOBC: hobc?.itemName || "",
          itemRateHOBC: hobc?.sRate || 0,
        });
      }
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const siteNameAddress = await getSiteRefrence(access_token);
      if (siteNameAddress.success) {
        setState({
          ...state,
          siteName: siteNameAddress.data.siteName,
          siteAddress: siteNameAddress.data.siteAddress,
          siteDealer: siteNameAddress.data.siteDealer,
        });
      }
      const tankResults = await getAllTank(access_token);
      const saleResults = await getNozelSale(
        { siteId: user.siteId },
        access_token
      );
      if (tankResults.success && saleResults.success) {
        const enrichedTankData = tankResults.data.map((tank) => ({
          ...tank,
          ...getColorForTank(tank.itemCode),
        }));
        setTankData(enrichedTankData);
        setSaleData(saleResults.data);
      } else {
        message.error("Failed to fetch data");
      }
    };
    fetchData();
    const intervalId = setInterval(fetchData, 5000);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, [user.siteId, access_token]);

  const calculateTotalQuantityForHose = (hoseType) => {
    return saleData
      .filter((ele) => ele.ICode === hoseType)
      .reduce((total, ele) => total + parseFloat(ele.Qty), 0);
  };

  const handlePrint = (rowData) => {
    const getItemName = (itemCode) => {
      switch (itemCode) {
        case 1:
          return "Petrol";
        case 2:
          return "Diesel";
        case 3:
          return "HOBC";
        default:
          return "Unknown Item";
      }
    };

    // const logoUrl = `/Logo/PakistanStateOilLogo.svg`; // ✅ loads from public folder
    const totalAmount = parseFloat(rowData.Amount || 0).toFixed(2);

    const printContent = `
      <style>
        @page {
          size: 80mm auto;
          margin: 0;
        }
        @media print {
          body {
            margin: 0;
            padding: 0;
            width: 80mm;
            font-family: 'Arial', sans-serif;
            font-size: 12px;
            color: #000;
          }
  
          .receipt {
            width: 80mm !important;
            padding: 5px;
            margin: 0 auto;
            text-align: left;
            line-height: 1.4;
          }
  
          .center { text-align: center; font-weight: bold; }
          .flex { display: flex; justify-content: space-between; }
          .bold { font-weight: bold; }
          hr { border: none; border-top: 1px dashed #000; margin: 5px 0; }
  
          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 13px;
            table-layout: fixed;
          }
          th, td {
            padding: 3px 0;
            white-space: nowrap;
            overflow: hidden;
          }
          th {
            border-bottom: 1px solid #000;
            text-align: left;
          }
  
          th:nth-child(1), td:nth-child(1) { width: 15%; text-align: left; }
          th:nth-child(2), td:nth-child(2) { width: 30%; text-align: left; }
          th:nth-child(3), td:nth-child(3) { width: 20%; text-align: right; }
          th:nth-child(4), td:nth-child(4) { width: 20%; text-align: right; }
          th:nth-child(5), td:nth-child(5) { width: 25%; text-align: right; }
  
          .total {
            font-weight: bold;
            border-top: 1px solid #000;
            padding-top: 4px;
            margin-top: 4px;
            font-size: 13px;
          }
  
          .footer {
            text-align: center;
            font-size: 15px;
            margin-top: 10px;
            border-top: 1px dashed #000;
            padding-top: 5px;
          }
        }
      </style>
  
      <div class="receipt">
        <div class="center">
          <img   src="./assets/PakistanStateOilLogoP.png" alt="" style="width:100px;height:100px;margin-bottom:5px;margin-top:2px;" />
        </div>
        <h1 class="center" style="font-size:20px; margin: 0;">${
          state.siteName
        }</h1>
        <h3 class="center" style="font-size:15px; margin: 0;">${
          state.siteAddress
        }</h3>
        <hr />
        <div class="flex">
          <span>Date: ${format(
            new Date(rowData.TDate),
            "dd/MM/yyyy HH:mm"
          )}</span>
          <span>Nozel: ${rowData.NZN}</span>
        </div>
        <hr />
        <table>
          <thead>
            <tr>
              <th>S#</th>
              <th>Item</th>
              <th>Qty</th>
              <th>Rate</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>${getItemName(rowData.ICode)}</td>
              <td>${Number(rowData.Qty).toFixed(2)}</td>
              <td>${Number(rowData.Rate).toFixed(2)}</td>
              <td>${Number(rowData.Amount).toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
        <hr />
        <div class="flex total">
          <span>Total Amount</span>
          <span>${totalAmount}</span>
        </div>
        <div class="footer">
          <p>Thank you for choosing ${state.siteName}!</p>
        </div>
      </div>
    `;

    const newWindow = window.open("", "_blank", "width=400,height=600");
    newWindow.document.write(printContent);
    newWindow.document.close();

    newWindow.onload = () => {
      newWindow.focus();
      newWindow.print();
      setTimeout(() => newWindow.close(), 500);
    };
  };

  useEffect(() => {
    let updatedTonight = false;

    const checkTimeAndUpdate = async () => {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const seconds = now.getSeconds();

      // Match exactly 23:59:40
      if (hours === 23 && minutes === 59 && seconds === 55 && !updatedTonight) {
        updatedTonight = true;

        try {
          for (const tank of tankData) {
            const totalUsed = calculateTotalQuantityForHose(tank.itemCode);
            const remainingVolume = tank.openingBalence - totalUsed;

            const data = {
              id: tank.id,
              tankNumber: tank.tankNumber,
              openingBalence: Number(remainingVolume.toFixed(2)),
            };

            const response = await updateTankBal(data, access_token);
            if (response.success) {
              console.log(
                `✅ ${tank.tankNumber} updated successfully: ${remainingVolume}`
              );
            } else {
              console.warn(
                `⚠️ Failed to update ${tank.tankNumber}: ${response.message}`
              );
            }
          }

          message.success("All tanks updated with remaining balances!");
        } catch (error) {
          console.error("Error updating tanks:", error);
          message.error("Error updating tanks automatically!");
        }
      }
    };
    fetchItems();

    const timer = setInterval(checkTimeAndUpdate, 1000);
    return () => clearInterval(timer);
  }, [tankData, saleData, access_token]);

  // const lowStockAudioRef = useRef(null);

  // useEffect(() => {
  //   lowStockAudioRef.current = new Audio("/alert.mp3");
  //   lowStockAudioRef.current.loop = true; // 🔥 important
  // }, []);

  // useEffect(() => {
  //   const isAnyLowStock = tankData.some((tank) => {
  //     const totalUsed = calculateTotalQuantityForHose(tank.itemCode);
  //     const remaining = tank.openingBalence - totalUsed;
  //     const percentage = (remaining / tank.volume) * 100;
  //     return percentage <= 20;
  //   });

  //   const audio = lowStockAudioRef.current;

  //   if (!audio) return;

  //   if (isAnyLowStock) {
  //     audio.play().catch(() => {});
  //   } else {
  //     audio.pause();
  //     audio.currentTime = 0; // reset
  //   }
  // }, [tankData, saleData]);

  return (
    <>
      <Header />
      <div className="flex flex-col md:flex-row md:items-start background">
        {user.role === "admin" && (
          <>
            <div className="flex-1 mt-5 md:ml-4 md:mr-4 grid grid-cols-2 gap-4">
              {tankData.map((tank, index) => {
                const totalUsed = calculateTotalQuantityForHose(tank.itemCode);
                const remainingVolume = tank.openingBalence - totalUsed;

                // keep for circle UI
                const percentage = (remainingVolume / tank.volume) * 100;

                // ✅ NEW LOGIC (DB based limit)
                const isLowStock = remainingVolume <= tank.lowLimit;

                return (
                  <div
                    key={index}
                    className="bg-white bg-opacity-20 backdrop-filter backdrop-blur-sm 
      hover:bg-opacity-30 transition duration-300 ease-in-out transform 
      hover:-translate-y-1 p-4 rounded-lg shadow-lg relative overflow-hidden"
                  >
                    {/* 🚨 LOW STOCK OVERLAY */}
                    {isLowStock && (
                      <div className="absolute inset-0 flex items-center justify-center z-20">
                        <div
                          className="bg-red-600 text-white px-6 py-3 rounded-xl 
            text-lg font-bold shadow-2xl animate-shake flex items-center gap-2"
                        >
                          ⛽ Low Fuel Level
                        </div>
                      </div>
                    )}

                    {/* 🔥 Dim background */}
                    {isLowStock && (
                      <div className="absolute inset-0 bg-black bg-opacity-40 rounded-lg"></div>
                    )}

                    {/* Item Name */}
                    {tank.itemCode === 1 && (
                      <p className="text-lg font-bold">
                        Item Name: {itemState.itemNamePetrol}
                      </p>
                    )}
                    {tank.itemCode === 2 && (
                      <p className="text-lg font-bold">
                        Item Name: {itemState.itemNameDiesel}
                      </p>
                    )}
                    {tank.itemCode === 3 && (
                      <p className="text-lg font-bold">
                        Item Name: {itemState.itemNameHOBC}
                      </p>
                    )}
                    <p className="text-lg font-semibold text-black">
                      Opening Bal: {tank.openingBalence}
                    </p>

                    {/* Remaining */}
                    <p
                      className={`text-lg font-bold ${
                        isLowStock ? "text-red-400" : "text-black"
                      }`}
                    >
                      Remaining:{" "}
                      {Number(remainingVolume.toFixed(0)).toLocaleString()}
                    </p>

                    {/* 🔹 Show Limit */}
                    {/* <p className="text-sm text-gray-500">
        Limit: {Number(tank.lowLimit).toLocaleString()}
      </p> */}

                    {/* Circle */}
                    <QuantityCircle
                      initial={tank.openingBalence}
                      used={totalUsed}
                      total={tank.volume}
                      color1={tank.color1}
                      color2={tank.color2}
                      id={`tank-${tank.id}`}
                    />
                  </div>
                );
              })}
            </div>
          </>
        )}
        <div className="flex-1 mt-5 md:mr-4 max-h-screen">
          {user.role === "admin" && (
            <div className="col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4 max-h-screen">
              {/* 🔥 LEFT SIDE — RATES */}
              <div className="bg-black text-white p-5 rounded-xl shadow-xl border border-gray-700">
                <h2 className="text-2xl font-bold mb-5 text-center tracking-wide">
                  📊 TODAY SALES
                </h2>

                <div className="space-y-4">
                  <div className="flex justify-between items-center bg-green-600 px-4 py-3 rounded-lg">
                    <span className="text-xl font-semibold">
                      {itemState.itemNamePetrol}
                    </span>
                    <span className="text-2xl font-bold">
                      {Number(
                        calculateTotalQuantityForHose(1).toFixed(2)
                      ).toLocaleString()}{" "}
                      Ltr
                    </span>
                  </div>

                  <div className="flex justify-between items-center bg-yellow-500 px-4 py-3 rounded-lg text-black">
                    <span className="text-xl font-semibold">
                      {itemState.itemNameDiesel}
                    </span>
                    <span className="text-2xl font-bold">
                      {Number(
                        calculateTotalQuantityForHose(2).toFixed(2)
                      ).toLocaleString()}{" "}
                      Ltr
                    </span>
                  </div>

                  <div className="flex justify-between items-center bg-red-600 px-4 py-3 rounded-lg">
                    <span className="text-xl font-semibold">
                      {itemState.itemNameHOBC}
                    </span>
                    <span className="text-2xl font-bold">
                      {Number(
                        calculateTotalQuantityForHose(3).toFixed(2)
                      ).toLocaleString()}{" "}
                      Ltr
                    </span>
                  </div>

                  <div className="flex justify-between items-center bg-gray-800 px-4 py-3 rounded-lg border border-gray-600">
                    <span className="text-2xl font-extrabold">Total</span>
                    <span className="text-3xl font-extrabold">
                      {Number(
                        (
                          calculateTotalQuantityForHose(1) +
                          calculateTotalQuantityForHose(2) +
                          calculateTotalQuantityForHose(3)
                        ).toFixed(2)
                      ).toLocaleString()}{" "}
                      Ltr
                    </span>
                  </div>
                </div>
              </div>

              {/* 💰 RIGHT SIDE — TODAY SALE */}
              <div className="bg-black text-white p-5 rounded-xl shadow-xl border border-gray-700">
                <h2 className="text-2xl font-bold mb-5 text-center tracking-wide">
                  ⛽ CURRENT FUEL RATES
                </h2>

                <div className="space-y-4">
                  <div className="flex justify-between items-center bg-green-600 px-4 py-3 rounded-lg">
                    <span className="text-xl font-semibold">
                      {itemState.itemNamePetrol}
                    </span>
                    <span className="text-2xl font-bold">
                      Rs. {itemState.itemRatePetrol}
                    </span>
                  </div>

                  <div className="flex justify-between items-center bg-yellow-500 px-4 py-3 rounded-lg text-black">
                    <span className="text-xl font-semibold">
                      {itemState.itemNameDiesel}
                    </span>
                    <span className="text-2xl font-bold">
                      Rs. {itemState.itemRateDiesel}
                    </span>
                  </div>

                  <div className="flex justify-between items-center bg-red-600 px-4 py-3 rounded-lg">
                    <span className="text-xl font-semibold">
                      {itemState.itemNameHOBC}
                    </span>
                    <span className="text-2xl font-bold">
                      Rs. {itemState.itemRateHOBC}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="border-black flex-1 overflow-x-scroll mt-5 md:mr-4 max-h-screen overflow-y-auto">
            <table className="min-w-full divide-y divide-gray-200 shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <thead className="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-bold text-black-700 uppercase tracking-wider"
                  >
                    SNo.
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-bold text-black-700 uppercase tracking-wider"
                  >
                    Date
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-bold text-black-700 uppercase tracking-wider"
                  >
                    NZN
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-bold text-black-700 uppercase tracking-wider"
                  >
                    Hose
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-bold text-black-700 uppercase tracking-wider"
                  >
                    Quantity
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-bold text-black-700 uppercase tracking-wider"
                  >
                    Rate
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-bold text-black-700 uppercase tracking-wider"
                  >
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {(user.role === "user" ? saleData.slice(0, 50) : saleData).map(
                  (ele, i) => (
                    <tr
                      className="hover:bg-gray-100 cursor-pointer transition"
                      key={i}
                      onDoubleClick={() => handlePrint(ele)}
                    >
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-black">
                        {i + 1}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-black">
                        {format(new Date(ele.TDate), "dd/MM/yyyy HH:mm:ss")}
                        {/* console.log({ele.TDate} , "Tdate")
                        console.log(new Date(ele.TDate)); */}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-black">
                        {ele.NZN}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-black">
                        {ele.ICode}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-black">
                        {ele.Qty}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-black">
                        {ele.Rate}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-black">
                        {ele.Amount}
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Saledata;
